import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import { OrganizationCreateForm } from '@openx/components-organization/lib/components/OrganizationForm/OrganizationCreateForm';
import { OrganizationEditForm } from '@openx/components-organization/lib/components/OrganizationForm/OrganizationEditForm';
import type { OrganizationsRouteParams } from '@openx/components-organization/lib/types';
import { useOrganizationContext } from '@openx/components-organization/lib/utils/context/OrganizationContext';
import { useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isAdmin } from '../../permissions/validators';

export const OrganizationFormPage = () => {
  const { session } = useAuth();
  const isAllowed = isAdmin(session);
  const { organizationId = '' } = useParams<OrganizationsRouteParams>();
  const { useOrganizationFetch } = useOrganizationContext();
  const { organization, loading } = useOrganizationFetch(organizationId);

  if (!isAllowed) return <AccessForbiddenPage />;
  if (loading) return <Loader />;
  if (!organizationId) return <OrganizationCreateForm />;

  if (!organization) {
    return <PageNotFound appName={'OpenXSelect'} />;
  }

  return <OrganizationEditForm currentOrganization={organization} />;
};
